exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-card {\n  max-width: 480px;\n  margin: 24px auto;\n}\n\n.input-full-width {\n  width: 100%;\n}\n\n.save-setting-buttons {\n  text-align: right;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings.component.css
// module id = 210
// module chunks = 1